<template>
  <!-- Parent route for the eight KarroFin modules. It used to carry a tab bar
       and a product switch; both moved out when the modules were promoted to
       the sidebar - the tabs became sidebar entries, and the product switch
       became a normal filter inside each screen's filter bar. What is left is
       the page gutter, shared so every module lines up identically. -->
  <div class="kf-shell">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "KarroFinLayout",
};
</script>

<style scoped>
.kf-shell {
  padding: 12px 16px 32px;
}

/* The drawer is `permanent` at 200px (64px collapsed), so on a narrow phone
   the content column is tight. Shrink the gutter rather than pushing the page
   sideways. */
@media (max-width: 700px) {
  .kf-shell {
    padding: 12px 8px 24px;
  }
}
</style>
